module.exports = __webpack_public_path__ + "img/pyrenees-strato.f531f5f8.png";